var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "follow" }, [
    _c("div", { staticClass: "l-center", attrs: { id: "follow" } }, [
      _c("div", { staticClass: "follow-link" }, [
        _c("a", {
          attrs: {
            "data-type": "facebook",
            title: "facebook",
            href: _vm.links.facebook,
          },
        }),
        _c("a", {
          attrs: {
            "data-type": "discord",
            title: "discord",
            href: _vm.links.discord,
          },
        }),
        _c("a", {
          attrs: {
            "data-type": "twitter",
            title: "twitter",
            href: _vm.links.twitter,
          },
        }),
        _c("a", {
          attrs: {
            "data-type": "instagram",
            title: "instagram",
            href: _vm.links.instagram,
          },
        }),
        _c("a", {
          attrs: {
            "data-type": "yutube",
            title: "yutube",
            href: _vm.links.youtube,
          },
        }),
        _c("a", {
          attrs: {
            "data-type": "reddit",
            title: "reddit",
            href: _vm.links.reddit,
          },
        }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }